const projectRecordStatuses = {
  active: { id: 'active', name: 'No' },
  archived: { id: 'archived', name: 'Yes' },
};

export default projectRecordStatuses;
